import React, { Fragment, useCallback, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { SUPER_SAFE_DELETE_CONFIRMATION_STRING } from './config';

export const DeleteModal = ( { visible = true, title, onOk, onCancel, superSafe = false, children } ) => {

    const [ loading, setLoading ] = useState( false );
    const [ allowDelete, setAllowDelete ] = useState( !superSafe );

    const handleDeleteCourseConfirm = useCallback( async () => {
        if ( onOk ) {
            const promiseOrResponse = onOk();
            const isPromise = Boolean( promiseOrResponse?.then );

            if ( isPromise ) {
                setLoading( true ); 
                promiseOrResponse.then( () => {
                    setLoading( false );
                } );
            }
        }
    }, [ onOk, setLoading ] );

    const handleDeleteCourseCancel = useCallback( () => {
        if ( onCancel && !loading ) {
            onCancel();
        }
    }, [ onCancel, loading ] );

    const handleInputChange = useCallback( ( e ) => {
        const value = e?.target?.value;
        const validInput = ( value.toLowerCase() === SUPER_SAFE_DELETE_CONFIRMATION_STRING.toLowerCase() );
        
        if ( allowDelete != validInput ) {
            setAllowDelete( validInput );
        }
    }, [ allowDelete, setAllowDelete ] );

    return (
        <Modal
            open={ visible }
            title={ title }
            onOk={ handleDeleteCourseConfirm }
            onCancel={ handleDeleteCourseCancel }
            footer={ [
                <Button
                    key="back"
                    disabled={ loading }
                    onClick={ handleDeleteCourseCancel }
                >
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    danger
                    disabled={ !allowDelete }
                    loading={ loading }
                    onClick={ handleDeleteCourseConfirm }
                >
                    Delete
                </Button>,
            ] }
        >
            { /* Render any children provided. */ }
            { children }

            { /* If super safe, require an extra input field before deleting. */ }
            { superSafe &&
                <Fragment>
                    <p><b>Type &apos;{ SUPER_SAFE_DELETE_CONFIRMATION_STRING }&apos; if you are certain you want to delete this item.</b></p>
                    <Input onChange={ handleInputChange } />
                </Fragment>
            }
        </Modal>
    );
};
